const URLType = ({ setUrlType }) => {
  return (
    <div className="p-6">
      <div className="space-y-5">
        <button
          type="button"
          className="w-full flex items-center justify-between rounded-lg border !border-[#d9d9d9] bg-white  transition-colors px-9 py-8 focus:outline-none group hover:!border-[#757575] hover:bg-[#f5f5f5]"
          onClick={() => setUrlType("single")}
        >
          <div className="text-left">
            <div className="text-base font-semibold text-black mb-2">
              Add a Webpage
            </div>
            <div className="text-sm text-[#757575]">
              Add <span className="font-semibold">one</span> page from website
            </div>
          </div>
          <span className="text-2xl text-black hidden group-hover:block">
            →
          </span>
        </button>
        <button
          type="button"
          className="w-full flex items-center justify-between rounded-lg border !border-[#d9d9d9] bg-white  transition-colors px-9 py-8 focus:outline-none group hover:!border-[#757575] hover:bg-[#f5f5f5]"
          onClick={() => setUrlType("multi")}
        >
          <div className="text-left">
            <div className="text-base font-semibold text-black mb-2">
              Add a Website
            </div>
            <div className="text-sm text-[#757575]">
              Add <span className="font-semibold">up to 10</span> pages from a
              website
            </div>
          </div>
          <span className="text-2xl text-black hidden group-hover:block">
            →
          </span>
        </button>
      </div>
    </div>
  );
};

export default URLType;
